import { useCallback, useEffect, useRef, useState } from 'react';

type Callback = () => void;

export function useInterval(callback: Callback, interval: number) {
    const [launched, setLaunched] = useState(false);
    const intervalRef = useRef<number | null>(null);
    const callbackRef = useRef<Callback | null>(null);

    const start = useCallback(() => {
        setLaunched(true);
        if (!intervalRef.current && callbackRef.current) {
            intervalRef.current = window.setInterval(callbackRef.current, interval);
        }
    }, []);

    const clear = useCallback(() => {
        setLaunched(false);
        if (intervalRef.current) {
            window.clearInterval(intervalRef.current);
        }
        intervalRef.current = null;
    }, []);

    useEffect(() => {
        callbackRef.current = callback;
        if (launched) {
            start();
        }
        return clear;
    }, [callback, launched, interval]);

    return { start, clear };
}
